import { useKeycloak } from "@react-keycloak/ssr";
import { KeycloakInstance } from "keycloak-js";
import { useRouter } from "next/router";
import React, { useEffect } from "react";
import { decrypt } from "utils/ecryption";

declare global {
  interface Window {
    tp: any;
  }
}

const RestrictedGuest: React.FC = () => {
  const { keycloak } = useKeycloak<KeycloakInstance>();
  const handleLogin = async () => {
    try {
      await keycloak?.login({
        redirectUri: `${window.location.href}`,
      });
    } catch (error) {
      console.error("Error during login:", error);
    }
  };

  const router = useRouter();
  useEffect(() => {
    let tp = window.tp || [];

    tp.push([
      "init",
      function () {
        if (keycloak) {
          tp.pianoId.loginByToken(decrypt(keycloak?.token));
        }
        tp.experience.execute();
      },
    ]);
    tp.push(["setUseTinypassAccounts", false]);
    tp.push(["setUsePianoIdUserProvider", false]);
    tp.push(["setUsePianoIdLiteUserProvider", true]);
    tp.push([
      "addHandler",
      "loginRequired",
      function (params) {
        handleLogin();
      },
    ]);
  }, []);
  return (
    <>
      <div style={{ width: "100%" }} id="locked-content"></div>
    </>
  );
};

export default RestrictedGuest;
